import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import ReactAppContext from './ReactAppContext';
import SrApp from '../SrApp';
import routes from '../routes';

/**
 * Root component.
 * This component provides the application's state in its child context,
 * and renders the main router component.
 */
@withRouter
class Root extends React.Component {
  static childContextTypes = {
    userAgent: PropTypes.object,
  };

  static propTypes = {
    apiClient: PropTypes.object.isRequired,
    utilityApiClient: PropTypes.object.isRequired,
    tree: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  };

  getChildContext() {
    return {
      userAgent: this.props.tree.get(['analytics', 'userAgent']),
    };
  }

  render() {
    const { apiClient, utilityApiClient, tree, history } = this.props;

    return (
      <ReactAppContext.Provider
        value={{
          tree,
          apiClient,
          utilityApiClient,
          history,
        }}
      >
        <SrApp routes={routes} apiClient={apiClient} />
      </ReactAppContext.Provider>
    );
  }
}

Root.displayName = 'Root';

export default Root;
